import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Search from './views/Search.vue';
import SingleWidget from './views/SingleWidget.vue';
import Comparison from './views/Comparison.vue';
import AuthCallback from './views/AuthCallback.vue';
import TABS from './constants/tabs';

Vue.use(Router);

const routes = [
  // adjust this to your need
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      isPublic: true,
      seo: {
        title: 'NetOX | Welcome',
      },
    },
  },
  {
    path: '/search/widget/:widgetId',
    name: 'singleWidget',
    component: SingleWidget,
    meta: {
      isPublic: true,
      seo: {
        title: `NetOX | Single Widget`,
      },
    },
  },
  {
    path: '/search/*',
    name: 'searchResult',
    meta: {
      isPublic: true,
    },
    beforeEnter: (to, from, next) => {
      try {
        // The $route.params has been changed since vue-router v3.1, so we need to use "pathMatch" to match an asterisk params.
        const query = to.params.pathMatch;
        let tab = TABS[0].id;
        if (to.hash) {
          to.hash.split('&').forEach((i) => {
            if (i.includes('#tab=')) {
              tab = i.split('#tab=')[1];
            }
          });
          if (!tab) {
            throw Error('no tab found');
          }
        }
        next(`/${tab}/${query}${to.hash}`);
      } catch (e) {
        next('/');
      }
    },
  },
  {
    path: '/auth-callback', // Needs to match redirect_uri in you oidcSettings
    name: 'authCallback',
    component: AuthCallback,
    meta: {
      isOidcCallback: true,
      isPublic: true,
    },
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () => import('./views/Disclaimer.vue'),
    meta: {
      isPublic: true,
      seo: {
        title: 'NetOX | Disclaimer',
      },
    },
  },
  {
    path: '/discover',
    name: 'discover',
    component: () => import('./views/DiscoverMoreTools.vue'),
    meta: {
      isPublic: true,
      seo: {
        title: 'NetOX | Discover',
      },
    },
  },
  // leave this at the bottom, also, this should be a temporary solution to handle 404 request
  { path: '*', redirect: '/' },
];

// put tabs on sidebar
TABS.forEach((i) => {
  routes.push({
    path: `/${i.id}/*`,
    name: i.id,
    component: i.id === 'apnic-comparison' ? Comparison : Search,
    meta: {
      isPublic: true,
      seo: {
        title: `NetOX | ${i.name}`,
      },
    },
  });
});

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = (to.meta && to.meta.seo && to.meta.seo.title) || 'NetOX';
  next();
});

// router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'authStore'));
export default router;
